import { loadingAsyncState } from 'widgets-for-react'

async function deleteCollection(collectionId: string): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(`/api/v1/collections/Delete/${collectionId}`, {
    method: 'delete',
    credentials: 'include',
    headers: headers,
  })
  if (!res.ok) throw Error(res.statusText)
  return
}

async function deleteComponent(
  collectionId: string,
  componentId: number
): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch('/api/v1/collections/DeleteComponent', {
    method: 'post',
    credentials: 'include',
    headers: headers,
    body: JSON.stringify({
      ComponentId: componentId,
      CollectionsIds: [collectionId],
    }),
  })
  if (!res.ok) throw Error(res.statusText)
  return
}

export const loadDeleteCollection = (
  collectionId: string,
  componentId?: number
) =>
  loadingAsyncState<{}>(() =>
    (componentId
      ? deleteComponent(collectionId, componentId)
      : deleteCollection(collectionId)
    ).then(() => ({
      kind: 'result',
      value: {},
      status: 200,
    }))
  )
